<!-- todo 仅用于数字控件 0 返回空 &千分位格式化，目前仅用于显示 临时使用 （财务审核 基本页签查看）-->
<template>
  <div class="pair-numeric-stepper">
    <el-input
      v-model="oneValue"
      :disabled="disable"
      type="number"
      :placeholder="onePrompt"
      @change="onChangeOne"
    />
    <el-input
      v-model="twoValue"
      :disabled="disable"
      type="number"
      :placeholder="twoPrompt"
      @change="onChangeTwo"
    />
    <el-input
      v-if="showThree"
      v-model="threeValue"
      :disabled="disable"
      type="number"
      :placeholder="threePrompt"
      @change="onChangeThree"
    />
    <el-checkbox v-model="nil" label="NIL" :disabled="nilDisabled" style="margin-left: 10px;" />
  </div>
</template>

<script>
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import { roundDecimalNum } from '@/utils'

export default {
  name: 'PairNumericStepper',
  props: {
    precision: { type: Number, default: 2 }, // 默认截取小数位数 2
    position: { type: String, default: '' },
    one: { type: Number, default: 0 },
    two: { type: Number, default: 0 },
    three: { type: Number, default: 0 },
    onePrompt: { type: String, default: '' },
    twoPrompt: { type: String, default: '' },
    threePrompt: { type: String, default: '' },
    showThree: { type: Boolean, default: false }
  },
  data() {
    return {
      nil: false,
      tact: false,
      nilDisabled: false,
      disable: false,
      oldOne: 0,
      oldTwo: 0,
      oldThree: 0,
      oneValue: null,
      twoValue: null,
      threeValue: null
    }
  },
  computed: {
  },
  watch: {
    nil: function(newVal) {
      if (newVal) {
        this.$emit('onChangeOne', PriceConstant.NIL)
        this.$emit('onChangeTwo', PriceConstant.NIL)
        this.$emit('onChangeThree', PriceConstant.NIL)
        this.oldOne = this.oneValue
        this.oldTwo = this.twoValue
        this.oldThree = this.threeValue
        this.oneValue = null
        this.twoValue = null
        this.threeValue = null
        this.disable = true
      } else {
        const one = this.oldOne !== PriceConstant.NIL ? this.oldOne : 0
        this.$emit('onChangeOne', Number(one))
        const two = this.oldTwo !== PriceConstant.NIL ? this.oldTwo : 0
        this.$emit('onChangeTwo', Number(two))
        const three = this.oldThree !== PriceConstant.NIL ? this.oldThree : 0
        this.$emit('onChangeThree', Number(three))
        this.disable = false
        this.oneValue = this.oldOne
        this.twoValue = this.oldTwo
        this.threeValue = this.oldThree
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (Number(this.one) === PriceConstant.NIL || Number(this.two) === PriceConstant.NIL || (this.showThree && Number(this.three) === PriceConstant.NIL)) {
        this.nil = true
        this.$emit('onChangeOne', 0)
        this.$emit('onChangeTwo', 0)
        this.$emit('onChangeThree', 0)
      } else {
        this.nil = false
      }
      this.oneValue = (this.one !== 0 && Number(this.one) !== PriceConstant.NIL) ? roundDecimalNum(this.one, this.precision) : null
      this.twoValue = (this.two !== 0 && Number(this.two) !== PriceConstant.NIL) ? roundDecimalNum(this.two, this.precision) : null
      this.threeValue = (this.three !== 0 && Number(this.three) !== PriceConstant.NIL) ? roundDecimalNum(this.three, this.precision) : null
    },
    onChangeOne(val) {
      const newVal = this.getValue(val)
      this.$emit('onChangeOne', Number(newVal))
      this.oneValue = newVal
    },
    onChangeTwo(val) {
      const newVal = this.getValue(val)
      this.$emit('onChangeTwo', Number(newVal))
      this.twoValue = newVal
    },
    onChangeThree(val) {
      const newVal = this.getValue(val)
      this.$emit('onChangeThree', Number(newVal))
      this.threeValue = newVal
    },
    getValue(val) {
      return roundDecimalNum(Number(val), this.precision)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/styles/element-variables.scss";
  .pair-numeric-stepper{
    display: flex;
    .el-input {
      width: 100%;
      margin-right: 4px;
      text-align:right;
    }
  }
</style>
